import { useState } from 'react'
import { Button, Input } from 'antd'
import { SendOutlined } from '@ant-design/icons'

type Props = {
  onSend: (text: string) => void
  onCancel: () => void
  isStreaming: boolean
  disabled: boolean
}

const MessageInput = ({ onSend, onCancel, isStreaming, disabled }: Props) => {
  const [input, setInput] = useState('')

  const handleSend = () => {
    const text = input.trim()
    if (!text) return
    onSend(text)
    setInput('')
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Escape' && isStreaming) {
      e.preventDefault()
      onCancel()
      return
    }
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
      <Input.TextArea
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={disabled ? 'Connecting...' : 'Ask a question...'}
        disabled={disabled || isStreaming}
        autoSize={{ minRows: 1, maxRows: 5 }}
        style={{ flex: 1, resize: 'none' }}
      />
      {isStreaming ? (
        <Button danger onClick={onCancel}>
          Stop
        </Button>
      ) : (
        <Button
          type="primary"
          icon={<SendOutlined />}
          onClick={handleSend}
          disabled={disabled || !input.trim()}
        />
      )}
    </div>
  )
}

export default MessageInput
